// extracted by mini-css-extract-plugin
module.exports = {"nonreturnable-icon-container":"NonReturnableIcon_nonreturnable-icon-container__Z8r4z"};